import './NoHotelProductsWarning.scss';
import Icon from '../../Icon';
import CTA from '../../Cta';
import { useTranslation } from '../../../hooks';
import { getConfig } from '@micro-apps/env';

interface Props {
	accomPath: string;
}

export default function NoHotelProductsWarning({ accomPath }: Props) {
	const { t } = useTranslation();

	const { STATIC_SITE_URL } = getConfig(process.env);

	return (
		<div className="NoHotelProductsWarning" data-cy="NoHotelProductsWarning">
			<Icon className="NoHotelProductsWarning__icon" icon="alert" />
			<span className="ty-b2">{t('To checkout, add a room to your cart')}</span>
			<CTA type="primary" theme="light" link={`${STATIC_SITE_URL}${accomPath}`}>
				{t('Check Rates')}
			</CTA>
		</div>
	);
}
